import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentFetchAction from './equipmentFetch.action.json' with { type: 'json' }
import { equipmentObject } from '../equipmentObject'

const equipmentFetchDefinition = defineAction({
  ...equipmentFetchAction,

  input: equipmentObject.pick({
    id: true,
  }),
  output: equipmentObject,
})

export default equipmentFetchDefinition
